export const environment = {
  production: false,
  serverIP: 'https://munsalik-api-dev.lfdanalytics.com/',
};
